import AdvertiserWhiteList from './components/AdvertiserWhiteList';

export default AdvertiserWhiteList;
